var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white",
    fillOpacity: 0.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.7945V28.1425C16 29.2626 16 29.823 16.218 30.2508C16.4097 30.6272 16.7155 30.9328 17.0918 31.1246C17.5192 31.3424 18.079 31.3424 19.1969 31.3424H28.8031C29.921 31.3424 30.48 31.3424 30.9074 31.1246C31.2837 30.9328 31.5905 30.6272 31.7822 30.2508C32 29.8234 32 29.2639 32 28.1459V22.7945C32 22.2602 31.9995 21.9929 31.9346 21.7442C31.877 21.5239 31.7825 21.3154 31.6546 21.1269C31.5102 20.9143 31.3096 20.738 30.9074 20.3861L26.1074 16.1861C25.3608 15.5328 24.9875 15.2063 24.5674 15.0821C24.1972 14.9726 23.8026 14.9726 23.4324 15.0821C23.0126 15.2063 22.6398 15.5324 21.8944 16.1847L17.0928 20.3861C16.6906 20.738 16.49 20.9143 16.3457 21.1269C16.2178 21.3154 16.1225 21.5239 16.065 21.7442C16 21.9929 16 22.2602 16 22.7945Z",
    stroke: "#1F6FA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9b72b6d24509cbdab693650524a048ba.svg";
export { ForwardRef as ReactComponent };